import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

// export const getProjectsList = (id, query, token) => {
//   let qs = buildQuery(query);
//   let url = `${baseUrl}/projects/user/${id}${qs}`;
//   return axios.get(url, {
//     headers: {
//       authorization: token,
//     },
//   });
// };

export const getAllExpenses = (token,query) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getAllExpenses${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};


export const insertExpensesData = (data, token) => {
  return axios.post(`${baseUrl}/insertExpenses`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const updateExpensebyID = (data, token,id) => {
  return axios.put(`${baseUrl}/updateExpensebyID/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const getExpensebyID = ( token,id) => {
  return axios.get(`${baseUrl}/getExpensebyID/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
